export const ONE_HOUR = '1H'
export const TWENTY_FOUR_HOURS = '24H'
export const ONE_WEEK = '1W'
export const ONE_MONTH = '1M'
export const ALL_TIME = 'All'

export const chartsPeriodArr = [ONE_HOUR, TWENTY_FOUR_HOURS, ONE_WEEK, ONE_MONTH, ALL_TIME] as const
